import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { getToken } from "./services/auth";
import { Toaster } from "react-hot-toast";
// import posthog from "posthog-js";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// // Initialize PostHog
// posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
//   api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
//   capture_pageview: true,
//   capture_pageleave: true,
//   loaded: (posthog) => {
//     if (import.meta.env.DEV) posthog.debug(false);
//   },
//   autocapture: true,
//   disable_session_recording: false,
//   // enable_recording_console_log: true
// });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode>,
);
